export const supportLanguages = [
  "Albanian",
  "Amharic",
  "Arabic",
  "Bengali",
  "Bosnian",
  "Bulgarian",
  "Burmese",
  "Catalan",
  "Chinese (Cantonese)",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Creole",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "Romanian",
  "Russian",
  "Serbian",
  "Slovak",
  "Slovenian",
  "English",
  "Farsi",
  "Finnish",
  "French",
  "French (Canadian)",
  "Georgian",
  "German",
  "Greek",
  "Gujrati",
  "Hebrew",
  "Hindi",
  "Hungarian",
  "Indonesian",
  "Indian English",
  "Spanish",
  "Swedish",
  "Swahili",
  "Tagalog",
  "Tajik",
  "Italian",
  "Japanese",
  "Korean",
  "Kannada",
  "Latin",
  "Latvian",
  "Lithuanian",
  "Macedonian",
  "Malay",
  "Marathi",
  "Nepali",
  "Norwegian",
  "Pashto",
  "Persian",
  "Polish",
  "Portuguese (Brazil)",
  "Portuguese (Portugal)",
  "Punjabi",
  "Tamil",
  "Telugu",
  "Thai",
  "Turkish",
  "Ukrainian",
  "Urdu",
  "Uzbek",
  "Vietnamese",
  "Kurdish",
  "Kurdish (Sorani)",
  "Kyrgyz",
  "Mongolian",
  "Azerbaijani",
  "Armenian",
  "Haitian Creole",
  "Malayalam",
  "Sinhala (Sinhalese)",
  "Lao",
  "Khmer",
  "Karen",
  "Estonian",
  "Hmong",
  "Kinyarwanda",
  "Oromo",
  "Shona",
  "Somali",
  "Serbian",
  "Maltese",
];

export const prices = [
  {
    price: 24.5,
    languages: [
      "Albanian",
      "Amharic",
      "Arabic",
      "Armenian",
      "Azerbaijani",
      "Bengali",
      "Bosnian",
      "Bulgarian",
      "Burmese",
      "Catalan",
      "Chinese (Cantonese)",
      "Chinese (Simplified)",
      "Chinese (Traditional)",
      "Creole",
      "Croatian",
      "Czech",
      "Danish",
      "Dutch",
      "English",
      "Estonian",
      "Farsi",
      "Finnish",
      "French",
      "French (Canadian)",
      "Georgian",
      "German",
      "Greek",
      "Gujrati",
      "Haitian Creole",
      "Hebrew",
      "Hindi",
      "Hmong",
      "Hungarian",
      "Indian English",
      "Indonesian",
      "Italian",
      "Japanese",
      "Kannada",
      "Karen",
      "Khmer",
      "Kinyarwanda",
      "Korean",
      "Kurdish",
      "Kurdish (Sorani)",
      "Kyrgyz",
      "Lao",
      "Latin",
      "Latvian",
      "Lithuanian",
      "Macedonian",
      "Malay",
      "Malayalam",
      "Maltese",
      "Marathi",
      "Mongolian",
      "Nepali",
      "Norwegian",
      "Oromo",
      "Pashto",
      "Persian",
      "Polish",
      "Portuguese (Brazil)",
      "Portuguese (Portugal)",
      "Punjabi",
      "Romanian",
      "Russian",
      "Serbian",
      "Shona",
      "Sinhala (Sinhalese)",
      "Slovak",
      "Slovenian",
      "Somali",
      "Spanish",
      "Swahili",
      "Swedish",
      "Tagalog",
      "Tajik",
      "Tamil",
      "Telugu",
      "Thai",
      "Turkish",
      "Ukrainian",
      "Urdu",
      "Uzbek",
      "Vietnamese",
    ],
  },
];
export const globalFeedbackList = [
  {
    title: "Expert Translators",
    content: "Top-quality translations from experienced professionals.",
  },
  {
    title: "Fast Turnaround",
    content: "Regular and premium delivery options to meet your deadlines.",
  },
  {
    title: "Competitive Pricing",
    content: "Affordable, upfront pricing with no hidden fees.",
  },
  {
    title: "Confidentiality",
    content: "Your privacy and document security are our priorities.",
  },
  {
    title: "Wide Language Selection",
    content: "Multiple language pairs are available.",
  },
  {
    title: "Satisfaction Guarantee",
    content: "We're committed to making it right if you're unsatisfied",
  },
];
